import {
  LoadLecturersAsync,
  LoadCourseNamesAsync,
  LoadLecturersCoursesAsync,
  ShowMyCartSummaryAsync,
} from './aka.js';
export async function mainostatni() {
  // spolecne pro staticke stranky -  dalsisluzby, kontakt, blog (jen kosik)
  console.log('ostatni');
  await ShowMyCartSummaryAsync();
}
